<template>
  <div class="container home_one-simple-wrapper pt-100">
    <div class="row align-items-end">
      <div class="col-lg-6">
        <div class="simple-content">
          <h2
            class="section-title"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            Never Miss Another Anniversary with Mazii
          </h2>
          <p data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
            Keep track of all your special moments with intelligent anniversary
            reminders and countdown widgets. From your first date to monthly
            milestones, Mazii ensures every precious memory gets the celebration it deserves.
          </p>
          <button
            @click="scrollToDownload"
            class="btn style-one"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            Start Celebrating Your Love Today
          </button>
          <div
            class="feature-content"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="400"
          >
            <div class="feature-item">
              <h5>
                <img src="../../assets/img/icons/check-2.svg" alt="Image" />
                Smart Anniversary Tracking
              </h5>
              <p>
                Automatically track important dates and milestones in your
                relationship. Set custom anniversaries and let Mazii remind you
                with beautiful notifications and countdown widgets.
              </p>
            </div>
            <div class="feature-item">
              <h5>
                <img src="../../assets/img/icons/check-2.svg" alt="Image" />
                Milestone Celebrations
              </h5>
              <p>
                 Create magical moments with personalized celebration suggestions.
                 From monthly anniversaries to special achievements, turn every
                 milestone into a memorable experience for both of you.
                </p>
              </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div
          class="simple-img-wrap"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="500"
        >
          <img
            src="../../assets/img/home-one/about/circle.webp"
            alt="Image"
            class="anniversary-shape-one"
          />
          <img
            src="../../assets/img/home-one/how-it-works/hw-bg.webp"
            alt="Image"
            class="anniversary-shape-two"
          />
          <img 
            src="../../assets/screenshots/screen_3.png" 
            alt="Image" 
            class="anniversary-img position-relative index-1 d-block mx-auto bounce"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Anniversary",
  methods: {
    scrollToDownload() {
      const downloadSection = document.getElementById('download-section');
      if (downloadSection) {
        downloadSection.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home_one-simple-wrapper {
  .simple-content {
    p {
      margin: 30px 0 40px;
    }
    .feature-content {
      border-radius: 10px;
      background-color: #f9f4ff;
      padding: 50px 50px 41px;
      margin-top: 70px;
      .feature-item {
        margin-bottom: 32px;
        &:last-child {
          margin-bottom: 0;
        }
        h5 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 14px;
          img {
            margin-right: 12px;
            position: relative;
            top: -2px;
          }
        }
        p {
          margin: 0;
        }
      }
    }
  }
  .simple-img-wrap {
    position: relative;
    right: 50px;
    .anniversary-shape-one,
    .anniversary-shape-two {
      position: absolute;
    }
    .anniversary-shape-one {
      top: 50%;
      left: 14%;
      transform: translateY(-50%);
      z-index: 0;
    }
    .anniversary-shape-two {
      bottom: 5%;
      right: 0;
      z-index: 0;
    }
    .anniversary-img {
      z-index: 1;
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_one-simple-wrapper {
    .simple-content {
      p {
        margin: 20px 0 30px;
      }
      .feature-content {
        padding: 35px 20px 30px;
        margin-top: 30px;
        .feature-item {
          margin-bottom: 20px;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .home_one-simple-wrapper {
    .simple-content {
      margin-bottom: 30px;
    }
  }
}

@media only screen and (min-width: 1400px) {
  .home_one-simple-wrapper {
    .simple-content {
      width: calc(100% + 8px);
      & > p {
        padding-right: 50px;
      }
    }
    .simple-img-wrap {
      position: relative;
      left: 7px;
    }
  }
}
</style>